import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Check Login
  if (!auth.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }
  // Check Role if route has roles
  const allowedRoles = route.data?.['roles'];
  if (allowedRoles) {
    const roles = (Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles]).map((role) =>
      auth.normalizeRoleForCompare(role),
    );
    const userRole = auth.normalizeRoleForCompare(auth.getUser()?.role);

    if (!roles.includes(userRole)) {
      router.navigate(['/dashboard']);
      return false;
    }
  }

  return true;
};
